(() => {
  const existing = window.OSOSetDescription;
  if (existing) {
    existing.enhance(document);
    return;
  }
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const enhance = root => {
    const descriptions = [...root.querySelectorAll('.oso-set-description')];
    if (root.matches?.('.oso-set-description')) descriptions.unshift(root);
    descriptions.forEach(description => {
      if (description.dataset.osoSetEnhanced === 'true') return;
      description.querySelectorAll('p, h2, h3, h4').forEach(element => {
        if (element.closest('table, li, blockquote')) return;
        if (element.querySelector('iframe[src*="youtube"], iframe[src*="vimeo"], video')) {
          element.classList.add('oso-set-description__media');
          return;
        }
        const isHeading = /^H[2-4]$/.test(element.tagName);
        const strong = [...element.children].find(child => /^(STRONG|B)$/.test(child.tagName));
        if (!isHeading && (!strong || normalize(element.textContent) !== normalize(strong.textContent))) return;
        if (!normalize(element.textContent)) return;
        const intro = /^combined\s+energy\b/i.test(normalize(element.textContent));
        element.classList.add('oso-set-description__heading');
        if (intro) element.classList.add('oso-set-description__heading--intro');
        if (!isHeading) {
          element.setAttribute('role', 'heading');
          element.setAttribute('aria-level', intro ? '2' : '3');
        }
      });
      description.dataset.osoSetEnhanced = 'true';
    });
  };
  window.OSOSetDescription = { enhance };
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
